const TestimonialsData = [
  {
    image: "/assets/Testimonial/t2.png",
    name: "Rohit Kumar",
    message:
      "I got a personal loan through Samast Bharat Finance, and the process was very smooth. Their team is helpful and quick. Thank you!",
    service: "Personal Loan",
    rating: 5,
  },
  {
    image: "/assets/Testimonial/t6.png",
    name: "Ashok Singh",
    message:
      "Samast Bharat Finance helped me secure a loan for my business. The entire experience was easy, and I am happy with their service.",
    service: "Business Loan",
    rating: 4,
  },
  {
    image: "/assets/Testimonial/t3.png",
    name: "Sushma Singha",
    message:
      "I wanted to save for my child’s education. Their savings plan is simple and fits my needs perfectly. Highly recommended!",
    service: "Savings Plan",
    rating: 5,
  },
  {
    image: "/assets/Testimonial/t5.png",
    name: "Sulekha Singh",
    message:
      "Their loan repayment process is very convenient, and the support team is always there to help. Great service!",
    service: "Loan Repayment Assistance",
    rating: 4,
  },
  {
    image: "/assets/Testimonial/7.png",
    name: "Krishna Bansal",
    message:
      "Thanks to FB-Finance, I now have a better understanding of how to invest my money. Their team explained everything very clearly.",
    service: "Investment Plans",
    rating: 5,
  },
  {
    image: "/assets/Testimonial/t8.jpeg",
    name: "Nagendra Marathi",
    message:
      "I used their EMI calculator to plan my loan. It’s super easy to use and saved me a lot of time. Great tool!",
    service: "EMI Calculator",
    rating: 4,
  },
  {
    image: "/assets/Testimonial/t11.png",
    name: "Rajni Rathor",
    message:
      "Their home loan process was quick and hassle-free. I am very happy with my decision to choose Samast Bharat Finance.",
    service: "Home Loan",
    rating: 5,
  },
  {
    image: "/assets/Testimonial/t4.png",
    name: "Suneeta Baghel",
    message:
      "Samast Bharat Finance has excellent customer service. They guided me step-by-step for my car loan. Highly satisfied!",
    service: "Car Loan",
    rating: 5,
  },
];

export default TestimonialsData;
